export default __webpack_public_path__ + "static/media/bannerSecondBg.8463565c.png";